import { render, staticRenderFns } from "./PrivacityNotice.vue?vue&type=template&id=2ca7c74c&scoped=true&"
import script from "./PrivacityNotice.vue?vue&type=script&lang=ts&"
export * from "./PrivacityNotice.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacityNotice.vue?vue&type=style&index=0&id=2ca7c74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7c74c",
  null
  
)

export default component.exports